export const getApiBaseUrl = () => {
  const hostname = window.location.hostname;
  
  // When running locally in development, target local backend
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "http://localhost:8091";
  }

  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.replace(/\/$/, "");
  }

  if (hostname === "toxbox-dev.provaantech.com") {
    return "https://dev.toxboxai.com";
  } else if (hostname === "toxboxai.com" || hostname === "www.toxboxai.com") {
    return "https://prod.toxboxai.com";
  }
  
  return "https://dev.toxboxai.com"; // Fallback
};

export const API_BASE_URL = getApiBaseUrl();

/**
 * Dynamic ProHireX / ProHireY API Base URL for subscription coordination.
 * Automatically resolves across Local (localhost:4000), Development (prohirex-dev-api),
 * and Production (api.prohirey.com) based on hostname and environment.
 */
export const getProhirexApiBaseUrl = () => {
  // 1. Explicit environment variable override
  if (process.env.REACT_APP_PROHIREX_API_URL) {
    return process.env.REACT_APP_PROHIREX_API_URL.replace(/\/+$/, "");
  }

  const hostname = typeof window !== "undefined" ? window.location.hostname : "";

  // 2. Local development
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "http://localhost:4000/api/v1";
  }

  // 3. Development / Staging
  if (hostname === "toxbox-dev.provaantech.com" || hostname.includes("dev")) {
    return "https://prohirex-dev-api.provaantech.com/api/v1";
  }

  // 4. Production
  if (hostname === "toxboxai.com" || hostname === "www.toxboxai.com" || hostname === "prod.toxboxai.com") {
    return "https://api.prohirey.com/api/v1";
  }

  return process.env.NODE_ENV === "production"
    ? "https://api.prohirey.com/api/v1"
    : "https://prohirex-dev-api.provaantech.com/api/v1";
};

export const PROHIREX_API_BASE_URL = getProhirexApiBaseUrl();

/**
 * Shared ToxBox Admin secret for authenticating admin calls to ProHireX Backend.
 * Allows managing plans, promo vouchers, and client keys across environments.
 */
export const TOXBOX_ADMIN_SECRET =
  process.env.REACT_APP_TOXBOX_ADMIN_SECRET ||
  'txbx_adm_9k4mPqR7vNsWzY2jC8dLhBfXuAeGiTo5';

export const getToxboxAdminHeaders = () => ({
  Authorization: `Bearer ${TOXBOX_ADMIN_SECRET}`,
});

/**
 * Appends _adminSecret query param to any direct ProHireX admin URL or proxy URL
 * to avoid browser CORS preflight restrictions while guaranteeing admin authorization.
 */
export const withAdminSecret = (url) => {
  if (!url) return url;
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}_adminSecret=${encodeURIComponent(TOXBOX_ADMIN_SECRET)}`;
};